import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {
  Label,
  InputGroup,
  Input,
  Select,
  FormGroup
} from 'reactstrap'

class FieldRadio extends Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedField: this.props.cardField.fieldValue
    }

    this.returnValue = this.returnValue.bind(this)
    this.handleRadioChange = this.handleRadioChange.bind(this)
  }

  returnValue() {
    return this.state.selectedField
  }

  handleRadioChange(ev) {
    this.setState({
      selectedField: ev.target.value
    })
  }

  render() {
    const fieldClassName = `card-field field-radio ${this.props.cardField.fieldClassName ? this.props.cardField.fieldClassName : ''}`

    return this.props.isEditing || this.props.cardType === 'always-on' ? <div className={fieldClassName}>
      <Label className="d-sm-block">{this.props.cardField.fieldLabel}</Label>
      <InputGroup className="mb-3 d-sm-block">
        {this.props.cardField.fieldValues.map(radioOption => {
          let radioKey = Object.keys(radioOption)[0]
          let radioValue = Object.values(radioOption)[0]

          return (
            <Label key={`radio-${radioKey}`} className="d-sm-block ml-4">
              <Input
                type={this.props.cardField.fieldType}
                key={this.props.cardField.id}
                name={this.props.cardField.id}
                value={radioKey}
                defaultChecked={radioKey === this.props.cardField.fieldValue}
                onChange={this.handleRadioChange}
                innerRef={el => { this[this.props.cardField.id] = el }}
              />{' '}
              {radioValue}
            </Label>
          )
        })}
      </InputGroup>
    </div> : <div className={fieldClassName}>
      <Label className="mb-0" for={this.props.cardField.id}>{this.props.cardField.fieldLabel}</Label>
      {this.props.cardField.fieldValues
        .filter(el => Object.keys(el)[0] === this.props.cardField.fieldValue)
        .map(radioOption => {
          return <div key={`radio-${this.props.cardField.id}`} className="mb-3">{Object.values(radioOption)[0]}</div>
        })
      }
    </div>
  }
}

FieldRadio.propTypes = {
  cardField: PropTypes.object,
  isEditing: PropTypes.bool,
  cardType: PropTypes.string
}

FieldRadio.defaultProps = {
  cardField: {
    cardSublabel: ''
  }
}

export default FieldRadio


// WEBPACK FOOTER //
// ./src/components/EditableCard/FieldRadio.js